<template>
  <v-dialog v-model="visible" persistent scrollable :max-width="600">
    <v-form ref="form" @submit="submit">
      <v-card>
        <dialog-header :title="$t('plannedService.moveToDateDialog.title')"
        :close="close"/>
        <v-card-text class="mt-5">
          <entity-dialog-input-row :label="$t('plannedService.moveToDateDialog.moveToDate')">
            <date-picker v-model="date"/>
          </entity-dialog-input-row>

        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="close" :disabled="submitting">
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn
              type="submit"
              tile
              color="primary"
              dark
              :loading="submitting"
          >
            {{ $t('plannedService.moveToDateDialog.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>


import DatePicker from '@/components/inputs/DatePicker';
import PlannedServiceService from '@/services/PlannedServiceService';
import DialogHeader from '@/components/layouts/DialogHeader';
import EntityDialogInputRow from '@/components/entity-crud/EntyDialogInputRow';

export default {
  components: { EntityDialogInputRow, DialogHeader, DatePicker },
  name: 'PlannedServiceInstanceMoveToDateDialog',
  data: () => ({
    visible: false,
    submitting: false,
    date: null,
    plannedServiceInstanceId: null,
  }),
  methods: {
    close() {
      this.visible = false;
      this.date = null;
      this.submitting = false;
    },
    open(plannedServiceInstanceId, scheduledDate) {

      if (!plannedServiceInstanceId || !scheduledDate) {
        throw Error('invalid input');
      }

      this.plannedServiceInstanceId = plannedServiceInstanceId;
      this.date = scheduledDate.substr(0, 10);
      this.submitting = false;
      this.visible = true;
    },

    submit(e) {
      e.preventDefault();
      if (this.submitting) {
        return;
      }

      this.submitting = true;

      PlannedServiceService.moveToDate(this.plannedServiceInstanceId, this.date).then(() => {
        this.$emit('done');
        this.close();
      }).catch(result => {
        console.log(JSON.stringify(result));
        this.submitting = false;
      });
    },
  },
};
</script>
